import React from "react";

const HeroSection = ({ title, subtitle, description }) => {
  // Logic: Title ko split karke last 2 words alag karna
  const words = title ? title.split(" ") : [];
  const lastTwo = words.slice(-2).join(" ");
  const rest = words.slice(0, -2).join(" ");

  return (
    <section className="relative  pt-32 pb-16 px-6 lg:px-16 overflow-hidden bg-[#f8f8f8] dark:bg-[#050505]">
      {/* GLOW Effects */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/10 blur-[140px] rounded-full pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/10 blur-[140px] rounded-full pointer-events-none" />

      {/* GRID BG */}
      <div className="absolute inset-0 opacity-50 bg-[linear-gradient(rgba(0,0,0,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.05)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:60px_60px]" />

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="text-center mb-8">
          {/* Subtitle (Dynamic) */}
          {subtitle && (
            <span className="text-primary mysubheading">
              {subtitle}
            </span>
          )}

          {/* Title (Dynamic with last 2 words gradient) */}
          <h2 className="myheading">
            {rest} <br />
            <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-500 bg-clip-text text-transparent">
              {lastTwo}
            </span>
          </h2>

          {/* Description (Dynamic) */}
          {description && (
            <p className="myparagraph text-gray-600 dark:text-gray-400">
              {description}
            </p>
          )}

          <div className="max-w-5xl mx-auto h-[1px] bg-primary mt-8"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;